import Vue from 'vue'
import { generateApiUrl } from '@/shared/utils'

const vm = Vue.prototype

const services = {
  create(payload:any) {
    // @ts-ignore
    const url = generateApiUrl(["azmoon", "analysis_algorithm"])
    return vm.$httpService.post(url, payload)
  },
  edit(payload:any, id:string|number) {
    // @ts-ignore
    const url = generateApiUrl(["azmoon", "analysis_algorithm_id"], [id])
    return vm.$httpService.put(url, payload)
  },
  partial_edit() {},
  delete() {},
  find(id:string|number,) {
    // @ts-ignore
    const url = generateApiUrl(["azmoon", "analysis_algorithm_id"], [id])
    return vm.$httpService.get(url)
  },
  list() {}
}
export default services;

